import { properties } from '@debbie/cortex/dist/api/index.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Modal from '../Modal.js';
import PerformedBy from '../performed-by/PerformedBy.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import PropertyData from './PropertyData.js';
const PropertyHistory = (props) => {
    const lang = useSelector((s) => s.lang);
    const [hist, setHist] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchPropertiesHist();
    }, []);
    const fetchPropertiesHist = async () => {
        if (!loading) {
            setLoading(true);
            const hist = await properties.historical(props.property.propRef, props.property.propRefId, props.property.handle);
            setLoading(false);
            setHist(hist);
        }
    };
    return (React.createElement(Modal, { header: lang.properties.historical, onToggle: props.onToggle, maxWidth: "500px" },
        loading ? (React.createElement(PlaceholderLoader, null)) : (hist.length === 0 && React.createElement("p", null, "No records yet.")),
        hist.map((histEntry) => (React.createElement(HistItem, null,
            histEntry.createdBy && (React.createElement(PerformedBy, { performedBy: histEntry.createdBy })),
            React.createElement("div", { style: {
                    padding: '0 10px',
                    flexGrow: 2,
                } },
                React.createElement(PropertyData, { property: histEntry })),
            React.createElement("small", null, moment(histEntry.createdAt).format(THEME.DATE_FORMAT_LONG)))))));
};
export default PropertyHistory;
const HistItem = styled.div `
  border-bottom: 1px solid lightgrey;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;

  small {
    float: right;
  }

  &:last-child {
    border-bottom: none;
  }
`;
//# sourceMappingURL=PropertyHistory.js.map